/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */

import * as form from '../form';

export const militaryHistory = (data = {}) => {
  const items = ((data.List || {}).items || []).map((x) => {
    const xitem = x.Item || {};
    return {
      Item: {
        Service: form.radio(xitem.Service), // Used in PVQ and SF8X
        Status: form.radio(xitem.Status), // Used in PVQ and SF8X
        Officer: form.radio(xitem.Officer),
        ServiceNumber: form.text(xitem.ServiceNumber),
        Dates: form.daterange(xitem.Dates), // Used in PVQ and SF8X
        ServiceState: form.location(xitem.ServiceState), // Used in PVQ and SF8X
        HasBeenDischarged: form.branch(xitem.HasBeenDischarged),
        DischargeType: form.radio(xitem.DischargeType), // Used in PVQ and SF8X
        DischargeTypeOther: form.text(xitem.DischargeTypeOther),
        DischargeReason: form.textarea(xitem.DischargeReason), // Used in PVQ and SF8X
        DischargeDate: form.datecontrol(xitem.DischargeDate),
        Country: form.country(xitem.Country),
        Comments: form.textarea(xitem.Comments),
        DischargeComments: form.textarea(xitem.DischargeComments),
        OtherThanHonorableComments: form.textarea(xitem.OtherThanHonorableComments),
        Rank: form.text(xitem.Rank), // PVQ Only
        StatusOtherExplanation: form.textarea(xitem.StatusOtherExplanation), // PVQ Only
        List: form.collection( // PVQ Only
          (xitem.List?.items || []).map((y) => {
            const yitem = y.Item || {};
            return {
              Item: {
                Has: form.branch(yitem.Has),
                DisciplinaryProcedureName: form.radio(yitem.DisciplinaryProcedureName),
                DisciplinaryProcedureOtherExplanation: form.textarea(yitem.DisciplinaryProcedureOtherExplanation),
                DisciplinaryDate: form.datecontrol(yitem.DisciplinaryDate),
                ReportedWithEmployment: form.branch(yitem.ReportedWithEmployment),
                WhatHappened: form.textarea(yitem.WhatHappened),
                Name: form.text(yitem.Name),
                GivenBy: form.name(yitem.GivenBy),
                GivenByNotApplicable: form.notapplicable(yitem.GivenByNotApplicable),
                CourtMartialType: form.radio(yitem.CourtMartialType),
                CourtMartialLocation: form.location(yitem.CourtMartialLocation),
                CourtMartialOffenseDate: form.datecontrol(yitem.CourtMartialOffenseDate),
                CourtMartialOffenseLocation: form.location(yitem.CourtMartialOffenseLocation),
                InvolvedDomesticViolence: form.branch(yitem.InvolvedDomesticViolence),
                InvolvedFirearms: form.branch(yitem.InvolvedFirearms),
                InvolvedExplosives: form.branch(yitem.InvolvedExplosives),
                InvolvedDrugs: form.branch(yitem.InvolvedDrugs),
                InvolvedAlcohol: form.branch(yitem.InvolvedAlcohol),
                CourtMartialCircumstances: form.textarea(yitem.CourtMartialCircumstances),
                List: form.collection( // PVQ Only, CourtMartialCharges
                  ((yitem.List || {}).items || []).map((z) => {
                    const zitem = z.Item || {};
                    return {
                      Item: {
                        Has: form.branch(zitem.Has),
                        CourtMartialChargeDescription: form.text(zitem.CourtMartialChargeDescription),
                        OutcomeType: form.radio(zitem.OutcomeType),
                        OutcomeExplanation: form.textarea(zitem.OutcomeExplanation),
                        OutcomeConsequences: form.checkboxgroup(zitem.OutcomeConsequences),
                        ConsequencesExplanation: form.textarea(zitem.ConsequencesExplanation),
                        // PVQ Part C-only below
                        ImprisonedWhen: form.daterange(zitem.ImprisonedWhen),
                        ParoleGranted: form.branch(zitem.ParoleGranted),
                        ParoleWhen: form.daterange(zitem.ParoleWhen),
                      },
                    };
                  }),
                  (yitem.List || {}).branch
                ),
              },
            };
          }),
          (xitem.List || {}).branch
        ),
      },
    };
  });
  return {
    HasServed: form.branch(data.HasServed), // Used in PVQ and SF8X
    HasServedMerchantMarine: form.branch(data.HasServedMerchantMarine),
    List: form.collection(items, (data.List || {}).branch),
    Comments: form.textarea(data.Comments),
    SummaryComments: form.textarea(data.SummaryComments),
  };
};
